import styled from 'styled-components'
import { sizeColors } from '~/design'
import { formatAsBrNumber } from '~/prix'

export type LegalEntitySizeLegendKey = 'MEI' | 'ME' | 'EPP' | 'Others'

export const legalEntitySizeLegendOrder: LegalEntitySizeLegendKey[] = ['MEI', 'ME', 'EPP', 'Others']

const legalEntitySizeLegendLabels: Record<LegalEntitySizeLegendKey, string> = {
  MEI: 'MEI',
  ME: 'ME',
  EPP: 'EPP',
  Others: 'Outros',
}

const LegendCard = styled.section`
  min-width: 260px;
  padding: 1rem;
  border-radius: 8px;
  box-shadow: ${({ theme }) => theme.shadow(1)};
  background-color: white;
  font-family: 'Figtree', Arial, sans-serif;

  @supports ((-webkit-backdrop-filter: none) or (backdrop-filter: none)) {
    background-color: ${({ theme }) => theme.backdropBackground};
    -webkit-backdrop-filter: ${({ theme }) => theme.backdropFilter};
    backdrop-filter: ${({ theme }) => theme.backdropFilter};
  }

  h2 {
    font-size: 0.7rem;
    font-weight: 700;
    margin: 0 0 0.3rem;
    text-transform: uppercase;
  }

  .total {
    margin: 0 0 0.65rem;
    font-size: 0.85rem;
    font-weight: 700;
    color: #363636;
  }

  .legend-list {
    display: flex;
    flex-direction: column;
    gap: 0.35rem;
  }

  .legend-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 0.75rem;
    font-size: 0.82rem;
    color: #363636;
  }

  .legend-label {
    display: flex;
    align-items: center;
    gap: 0.45rem;
  }

  .legend-dot {
    width: 12px;
    height: 12px;
    border-radius: 3px;
    flex-shrink: 0;
  }

  .legend-value {
    font-weight: 700;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.mobile}px) {
    min-width: 0;
    width: min(300px, calc(100vw - ${({ theme }) => theme.padding(1.2)}));
  }
`

interface LegalEntitySizeLegendProps {
  visibleTotal: number
  visibleTotalsBySize: Record<LegalEntitySizeLegendKey, number>
  unitPlural: string
}

export default function LegalEntitySizeLegend({
  visibleTotal,
  visibleTotalsBySize,
  unitPlural,
}: LegalEntitySizeLegendProps) {
  return (
    <LegendCard>
      <h2>Legenda</h2>
      <p className='total'>
        Total visível: {formatAsBrNumber(visibleTotal, 0)} {unitPlural}
      </p>
      <div className='legend-list'>
        {legalEntitySizeLegendOrder.map(sizeKey => (
          <div className='legend-item' key={sizeKey}>
            <div className='legend-label'>
              <span
                className='legend-dot'
                style={{
                  backgroundColor: sizeColors[sizeKey] ?? sizeColors.Others,
                }}
              />
              <span>{legalEntitySizeLegendLabels[sizeKey]}</span>
            </div>
            <span className='legend-value'>
              {formatAsBrNumber(visibleTotalsBySize[sizeKey], 0)}
            </span>
          </div>
        ))}
      </div>
    </LegendCard>
  )
}
